import React from "react";
import CalendarView from "features/CalendarView/CalendarView";
import FixedIntervals from "shared/CalendarView/FixedIntervals.shared";
import connect from "glassRedux/connect";

export class CalendarViewShared extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollToLocation: "unset",
    };
    this.setScrollToLocation = this.setScrollToLocation.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.disabled && this.props.disabled) {
      return false;
    }
    const result =
      nextProps.direction !== this.props.direction ||
      nextProps.disabled !== this.props.disabled ||
      nextProps.selectedDate !== this.props.selectedDate ||
      (nextProps.calendarItems !== this.props.calendarItems &&
        !nextProps.hasBlankTask &&
        !this.props.hasBlankTask &&
        !nextProps.hasEmptyDay &&
        !this.props.hasEmptyDay) ||
      nextProps.isSomeday !== this.props.isSomeday ||
      nextProps.itemType !== this.props.itemType ||
      nextProps.scrollOffset !== this.props.scrollOffset ||
      nextState.scrollToLocation !== this.state.scrollToLocation ||
      nextProps.activeDate !== this.props.activeDate ||
      nextProps.isCondensed !== this.props.isCondensed ||
      nextProps.isShort !== this.props.isShort;
    return result;
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.selectedDate !== this.props.selectedDate ||
      prevProps.isSomeday !== this.props.isSomeday
    ) {
      if (this.props.selectedDate.getFullYear() === 5000) {
        this.props.setIsSomeday(true);
      } else {
        if (this.props.isSomeday) {
          this.props.setIsSomeday(false);
        } else {
          this.props.setScrollOffset(this.getScrollHeight());
        }
      }
    }
    if (prevProps.direction !== this.props.direction) {
      if (this.props.direction === "reverse") {
        this.setScrollToLocation("bottom");
      } else if (this.props.direction === "forward") {
        this.setScrollToLocation("top");
      }
    }
  }

  setScrollToLocation(value) {
    this.setState({ scrollToLocation: value });
  }

  getScrollHeight() {
    return (
      this.props.dateHelper.heightOnCalendar(this.props.selectedDate, {
        beforeToday: this.props.direction === "reverse",
        isCondensed: this.props.isCondensed,
      }) - (this.props.offsetAboveSelectedDate || 0)
    );
  }

  render() {
    const { itemType } = this.props;
    const fixedIntervals = (
      <FixedIntervals
        setSelectedDate={this.props.setSelectedDate}
        dateHelper={this.props.dateHelper}
        isSomedayDisabled={
          itemType == "calendar_note" || itemType == "appointment"
        }
        setIsSomeday={this.props.setIsSomeday}
        isCalReversed={this.props.direction === "reverse"}
      />
    );
    return (
      <CalendarView
        {...this.props}
        {...{ fixedIntervals }}
        scrollToLocation={this.state.scrollToLocation}
        setScrollToLocation={this.setScrollToLocation}
        willBeCondensedRef={this.willBeCondensedRef}
      />
    );
  }
}


function mapStateToProps(state) {
  return { hasEmptyDay: state.itemLists.insertStatus.hasEmptyDay };
}

export default connect(mapStateToProps)(CalendarViewShared);
